import { render } from "./NewsIcon.vue?vue&type=template&id=df8659a0"
import script from "./NewsIcon.vue?vue&type=script&lang=js"
export * from "./NewsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__